import { push } from 'connected-react-router'

export const redirectToNotFound = () => {
    return dispatch => {
        dispatch(push('/notFound'));
    }
}

export const redirectToNotProduced = () => {
    return dispatch => {
        dispatch(push('/notProduced'));
    }
}

export const redirectToCanceled = () => {
    return dispatch => {
        dispatch(push('/canceled'));
    }
}